export default __webpack_public_path__ + "static/media/image_2021_02_18T14_39_10_071Z.8778dffb.png";